(function (global) {
  'use strict';

  if (global.MaxlerReviewEncoding) return;

  var leads = { '\u00c2': 194, '\u00c3': 195, '\u00d0': 208, '\u00d1': 209, '\u00e2': 226, '\u00ef': 239, '\u00f0': 240 };
  var cp1252 = [0x20ac, 0x81, 0x201a, 0x192, 0x201e, 0x2026, 0x2020, 0x2021, 0x2c6, 0x2030, 0x160, 0x2039, 0x152, 0x8d, 0x17d, 0x8f, 0x90, 0x2018, 0x2019, 0x201c, 0x201d, 0x2022, 0x2013, 0x2014, 0x2dc, 0x2122, 0x161, 0x203a, 0x153, 0x9d, 0x17e, 0x178];
  var byteMap = Object.create(null);
  for (var b = 0; b < 256; b++) byteMap[String.fromCharCode(b)] = b;
  for (var c = 0; c < cp1252.length; c++) byteMap[String.fromCharCode(cp1252[c])] = c + 128;

  function repair(value) {
    var s = String(value);
    for (var pass = 0; pass < 3; pass++) {
      var out = '', changed = false;
      for (var i = 0; i < s.length;) {
        var lead = leads[s[i]], width = lead == null ? 0 : lead < 224 ? 2 : lead < 240 ? 3 : 4;
        if (width && i + width <= s.length) {
          var raw = [], valid = true;
          for (var j = i; j < i + width; j++) {
            if (!Object.prototype.hasOwnProperty.call(byteMap, s[j])) { valid = false; break; }
            raw.push(byteMap[s[j]]);
          }
          if (valid) {
            try {
              var decoded = new TextDecoder('utf-8', { fatal: true }).decode(new Uint8Array(raw));
              if ([...decoded].length === 1 && decoded.codePointAt(0) >= 160) {
                out += decoded; i += width; changed = true; continue;
              }
            } catch (_) {}
          }
        }
        out += s[i++];
      }
      s = out;
      if (!changed) break;
    }
    return s;
  }

  var api = { repair: repair };
  global.MaxlerReviewEncoding = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;

  if (!global.document || !global.MutationObserver) return;
  var main = global.document.getElementById('MainContent');
  if (!main) return;

  var widgetSelector = '.jdgm-review-widget';
  var fieldSelector = '.jdgm-rev__title, .jdgm-rev__body';
  var excluded = { SCRIPT: true, STYLE: true, TEXTAREA: true };

  function inWidget(element) {
    return element && element.closest && element.closest(widgetSelector);
  }

  function fixText(node) {
    if (!node || node.nodeType !== 3 || !node.parentElement) return;
    var field = node.parentElement.closest(fieldSelector);
    if (!field || !inWidget(field)) return;
    var parent = node.parentElement;
    while (parent && parent !== field) {
      if (excluded[parent.tagName]) return;
      parent = parent.parentElement;
    }
    if (parent !== field) return;
    var fixed = repair(node.nodeValue);
    if (fixed !== node.nodeValue) node.nodeValue = fixed;
  }

  function fixField(field) {
    if (!field || !field.matches || !field.matches(fieldSelector) || !inWidget(field)) return;
    var walker = global.document.createTreeWalker(field, global.NodeFilter.SHOW_TEXT);
    var nodes = [], node;
    while ((node = walker.nextNode())) nodes.push(node);
    for (var i = 0; i < nodes.length; i++) {
      var parent = nodes[i].parentElement;
      while (parent && parent !== field) {
        if (excluded[parent.tagName]) break;
        parent = parent.parentElement;
      }
      if (parent === field) fixText(nodes[i]);
    }
  }

  function fixWidget(widget) {
    if (!widget || !widget.matches || !widget.matches(widgetSelector)) return;
    var fields = widget.querySelectorAll(fieldSelector);
    for (var i = 0; i < fields.length; i++) fixField(fields[i]);
  }

  function processAdded(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches(widgetSelector)) fixWidget(node);
    else {
      var widget = inWidget(node);
      if (widget) {
        if (node.matches(fieldSelector)) fixField(node);
        var fields = node.querySelectorAll(fieldSelector);
        for (var i = 0; i < fields.length; i++) fixField(fields[i]);
      } else {
        var widgets = node.querySelectorAll(widgetSelector);
        for (var j = 0; j < widgets.length; j++) fixWidget(widgets[j]);
      }
    }
  }

  var widgets = main.querySelectorAll(widgetSelector);
  for (var i = 0; i < widgets.length; i++) fixWidget(widgets[i]);

  var observer = new global.MutationObserver(function (records) {
    for (var r = 0; r < records.length; r++) {
      var record = records[r];
      if (record.type === 'characterData') fixText(record.target);
      else {
        var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        var field = target && target.closest && target.closest(fieldSelector);
        if (field && inWidget(field)) fixField(field);
        for (var n = 0; n < record.addedNodes.length; n++) processAdded(record.addedNodes[n]);
      }
    }
  });
  observer.observe(main, { subtree: true, childList: true, characterData: true });
})(typeof window !== 'undefined' ? window : globalThis);
